import { PeerGroupCapitalizationService } from "../service/asyncBatchPeerGroupCapitalizationService";
import * as validations from "../utils/validations";

export class PeerGroupCapitalizationFunctions {
  fnBurgissCalcPeerGroupCapitalization(
    investId?: any[][],
    peerGroupId?: any[][],
    endDate?: any,
    currency?: string,
    returnConstituentCount?: any,
    dynamicParameter?: string,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    if (investId == null) {
      return "#ERROR - Required parameters not defined";
    }
    if (String(investId).includes("Error")) {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    } else if (String(investId).includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }

    peerGroupId = validations.isValidPeerGroupIDRank(peerGroupId);

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    if (endDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    endDate = new Date(endDate).toLocaleDateString();
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }
    dynamicParameter = validations.validDynamicParameter(dynamicParameter);
    if (String(dynamicParameter).includes("Error")) {
      let str = String(dynamicParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }

    return new PeerGroupCapitalizationService().burgissCalcPeerGroupCapitalization(
      investId,
      peerGroupId,
      endDate,
      currency,
      returnConstituentCount,
      dynamicParameter,
      uniqueCellId
    );
  }
}
